import { useParams } from 'react-router-dom'
import { Trash } from '@styled-icons/boxicons-solid'
import { Menu } from '@styled-icons/boxicons-regular/Menu'

import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../../../services/base'
import Button from '../../../../common/Button'
import { useContext, useState } from 'react'
import { FunctionalDiagramEditContext } from '../context/context'
import { NavContext } from '../../../../../context/global_context'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import InputText from '../../../../common/InputText'
import CheckBox from '../../../../common/CheckBox'
import NoRecordsFound from '../../../../common/NoRecordsFound'
import { ProgresSpinner } from '../../../../common/ProgresSpinner'
import TextArea from '../../../../common/TextArea'

const FunctionalDiagramPreview = () => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [showPreviewPopup, setShowPreviewPopup] = useState(false)
  const [previewUrl, setPreviewUrl] = useState('')
  const [salesCodeList, setSalesCodeList] = useState([])
  const [searchSalesCode, setSearchSalesCode] = useState(null)
  const [selectedSalesCodes, setSelectedSalesCodes] = useState([])
  const [salesCodeListName, setSalesCodeListName] = useState('')
  const [filterData, setFilterData] = useState([])
  const [salesCodesData, setSalesCodesData] = useState([])
  const [selectedSalesCodeListId, setSelectedSalesCodeListId] = useState(null)
  const [selectedSalesCodeListData, setSelectedSalesCodeListData] = useState({})
  const [showLoader, setShowLoader] = useState(false)
  const [importJson, setImportJson] = useState({ show: false, data: '' })

  const showDiagramPreview = async () => {
    setSelectedSalesCodes([])
    setSelectedSalesCodeListId(null)
    setPreviewUrl(null)
    setShowPreviewPopup(true)
    getSalesCodeList()
    getSalesCodes()
    setImportJson({ show: false, data: '' })
    setSalesCodeListName(null)
  }

  const initializeBlockDiagramPreview = async (
    salesCodeListId,
    sales_code_data = []
  ) => {
    if (salesCodeListId || sales_code_data.length > 0) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Loading Block Diagram Preview',
          showLoader: true,
        },
        notification: {},
      })

      const res = await postRequest(
        `/api/functional_diagram/preview/${vehicle}/${state?.functionalDiagramDetails?.id}/`,
        { salesCodeListId: salesCodeListId, sales_code_data: sales_code_data }
      )
      if (res?.status) {
        setShowPreviewPopup(true)
        setPreviewUrl(res.data?.preview_url)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.data.msg,
          },
        })
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Please Select At Least One Sales Code List',
        },
      })
    }
  }

  const getSalesCodeList = async () => {
    setShowLoader(true)
    let res = await getRequest(`/api/option_code_list/all/?vehicle=${vehicle}`)
    setSalesCodeList(res.data)
    setShowLoader(false)
  }

  const showHidePreviewLoader = (showLoader = false) => {
    navDispatch({
      type: 'loader',
      data: showLoader
        ? {
            caption: 'Loading Block Diagram Preview',
            showLoader: true,
          }
        : {
            caption: '',
            showLoader: false,
          },
      notification: {},
    })
  }

  const getSalesCodes = async () => {
    let res = await getRequest(`/api/option_codes/options/?vehicle=${vehicle}`)
    setSalesCodesData(res?.data)
    setFilterData(res.data)
  }

  const selectSalesCodes = (id) => {
    let tempselectedSalesCodes = [...selectedSalesCodes]
    if (tempselectedSalesCodes.includes(id)) {
      const index = tempselectedSalesCodes.indexOf(id)
      tempselectedSalesCodes.splice(index, 1)
    } else {
      tempselectedSalesCodes.push(id)
    }
    setSelectedSalesCodes(tempselectedSalesCodes)
  }

  const saveSalesCodeListData = async (e) => {
    e.preventDefault()

    if (salesCodeListName) {
      if (
        window.confirm(
          `Are you sure want to block diagram preview with given data ?`
        ) === true
      ) {
        navDispatch({
          type: 'loader',
          data: {
            caption: 'Saving Sales Code List',
            showLoader: true,
          },
          notification: {},
        })
        let res = await postRequest(
          `/api/option_code_list/save_sales_code_list/?vehicle=${vehicle}`,
          {
            name: salesCodeListName,
            sales_code: selectedSalesCodes,
            vehicle: vehicle,
          }
        )
        if (res?.status) {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'success',
              msg: res?.msg,
            },
          })
          getSalesCodeList()
          setSelectedSalesCodeListId(res.id)
          setSalesCodeListName(null)
          setSelectedSalesCodes([])
          initializeBlockDiagramPreview(res.id)
        } else {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'error',
              msg: res?.msg,
            },
          })
        }
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Please Enter Sales Code List Name',
        },
      })
    }
  }

  const getSalesCodeDataForSelectedList = async (salesCodeListId) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Loading Sales Code List',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/option_code_list/sales_code/${salesCodeListId}/`
    )
    if (res?.status) {
      setSelectedSalesCodeListData({ data: res?.data, id: salesCodeListId })
    } else {
      setSelectedSalesCodeListData({ data: [], id: salesCodeListId })
    }

    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  const resetPreviewData = () => {
    setShowPreviewPopup(false)
    setPreviewUrl(null)
    setSelectedSalesCodeListId(null)
    setSelectedSalesCodeListData({ data: {}, id: null })
    setSelectedSalesCodes([])
  }

  const deleteSalesCodeList = async (id) => {
    if (
      window.confirm(`Are you sure you want to delete selected List Item`) ===
      true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Selected Sales Code List',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(
        `/api/option_code_list/${id}/?vehicle=${vehicle}`
      )
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'Selected Item deleted successfully',
        },
      })
      getSalesCodeList()
    }
  }
  const parseSalesCodeData = async () => {
    try {
      let salesCodeData = JSON.parse(importJson.data)
      if (salesCodeData?.sales_codes?.length > 0) {
        if (salesCodeListName) {
          if (
            window.confirm(
              `Are you sure want to block diagram preview with given data ?`
            ) === true
          ) {
            let res = await postRequest(
              `/api/option_code_list/save_sales_code_list/?vehicle=${vehicle}`,
              {
                name: salesCodeListName,
                sales_code: salesCodeData?.sales_codes,
                vehicle: vehicle,
              }
            )
            if (res?.status) {
              navDispatch({
                type: 'notification',
                data: {
                  notification_type: 'success',
                  msg: res?.msg,
                },
              })
              getSalesCodeList()
              setSelectedSalesCodeListId(res.id)
              setSalesCodeListName(null)
              setSelectedSalesCodes([])
              initializeBlockDiagramPreview(res.id)
            }
          }
        } else {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'error',
              msg: 'Please Enter Sales Code List Name ',
            },
          })
        }
      } else {
        throw new Error('Invalid Json Given')
      }
    } catch (error) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Please give valid json',
        },
      })
    }
  }

  return (
    <>
      {showLoader && (
        <div className="loading-overlay">
          <ProgresSpinner caption={'Loading ...'} />
        </div>
      )}

      {showPreviewPopup && (
        <Modal
          onClose={() => {
            resetPreviewData()
          }}
          show={showPreviewPopup}
          size={'functional-diagram-preview-container'}
        >
          <ModalHeader className={'text-white'}></ModalHeader>
          <ModalBody>
            {previewUrl ? (
              <>
                <a
                  onClick={() => {
                    setPreviewUrl(null)
                  }}
                  className="cursor-pointer text-white underline"
                >
                  Select Sales Code
                </a>
                <iframe
                  src={previewUrl}
                  style={{ height: '85vh', width: '100%', paddingTop: '1%' }}
                  title={'Functional Diagram Preview'}
                  onLoad={() => {
                    showHidePreviewLoader(false)
                  }}
                />
              </>
            ) : (
              <div className="flex justify-between">
                <div className="w-1/2 px-3">
                  <div className="text-white flex items-center justify-between">
                    {importJson.show ? (
                      <>
                        <div className="text-xl">Add Sales Code Json</div>
                        <Button
                          text={`Select Sales Codes`}
                          className={`cursor-pointer btn my-1 justify-end ml-2 w-1/4`}
                          onClick={(e) => {
                            e.preventDefault()
                            setImportJson({ show: false, data: '' })
                            setSalesCodeListName(null)
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <div className="text-xl">Select Sales Code</div>
                        <Button
                          text={`Import Json`}
                          className={`cursor-pointer btn my-1 justify-end ml-2 w-1/4`}
                          onClick={(e) => {
                            e.preventDefault()
                            setImportJson({ show: true, data: '' })
                            setSalesCodeListName(null)
                          }}
                        />
                      </>
                    )}
                  </div>
                  {importJson.show ? (
                    <form
                      onSubmit={(e) => {
                        saveSalesCodeListData(e)
                      }}
                      name="sales-code-list"
                      key={'sales-code-list-form'}
                      className=""
                    >
                      <TextArea
                        name="sales-code-json"
                        value={importJson.data}
                        onChange={(e) => {
                          setImportJson({ ...importJson, data: e })
                        }}
                        wrapperClass="p-0"
                        isRequired={false}
                        placeholder={`Sales Code Json`}
                        className="h-50vh"
                      />
                      <div className="flex justify-end py-3">
                        <InputText
                          name="sales_code_list_name"
                          placeholder={`Enter Sales Code List Name...`}
                          className={`w-100`}
                          value={salesCodeListName}
                          isFullSize={true}
                          type="text"
                          onChange={(value) => {
                            setSalesCodeListName(value)
                          }}
                          isRequired={true}
                          wrapperClass={`pl-0`}
                        />
                        <Button
                          className={`cursor-pointer btn my-1 justify-end ml-2`}
                          text={`Save Sales Code List`}
                          onClick={(e) => {
                            e.preventDefault()
                            parseSalesCodeData()
                          }}
                        />
                      </div>
                    </form>
                  ) : (
                    <>
                      <div className="py-2">
                        <form name="sales-code-search" className="">
                          <InputText
                            name="search_value"
                            placeholder={`Search Sales Code...`}
                            className={`w-100`}
                            value={searchSalesCode}
                            isFullSize={true}
                            type="search"
                            onChange={(value) => {
                              setSearchSalesCode(value)
                              setFilterData(
                                salesCodesData.filter((sales_code) =>
                                  sales_code?.label
                                    ?.toLocaleLowerCase()
                                    .includes(value.toLocaleLowerCase())
                                )
                              )
                            }}
                            isRequired={false}
                            wrapperClass={`pl-0`}
                          />
                        </form>
                      </div>
                      <div
                        className="py-2"
                        style={{ height: '60vh', overflowY: 'auto' }}
                      >
                        {filterData?.map((salesCode, salesCodeIdx) => {
                          return (
                            <span
                              className={`rounded-xl  p-2 px-3 text-white cursor-pointer inline-block mr-1 mb-1 preview-sales-code ${selectedSalesCodes.includes(salesCode.value) && 'bg-tracer-lt-blue '}`}
                              key={`sales-code-${salesCodeIdx}`}
                              onClick={() => {
                                selectSalesCodes(salesCode.value)
                              }}
                              style={{ border: '1px solid' }}
                            >
                              {salesCode.label}
                            </span>
                          )
                        })}
                        {filterData?.length == 0 && <NoRecordsFound />}
                      </div>
                    </>
                  )}

                  {selectedSalesCodes?.length > 0 && (
                    <form
                      onSubmit={(e) => {
                        saveSalesCodeListData(e)
                      }}
                      name="sales-code-list"
                      key={'sales-code-list-form'}
                      className="flex justify-end py-3"
                    >
                      <InputText
                        name="sales_code_list_name"
                        placeholder={`Enter Sales Code List Name...`}
                        className={`w-100`}
                        value={salesCodeListName}
                        isFullSize={true}
                        type="text"
                        onChange={(value) => {
                          setSalesCodeListName(value)
                        }}
                        isRequired={true}
                        wrapperClass={`pl-0`}
                      />
                      <Button
                        className={`cursor-pointer btn my-1 justify-end ml-2`}
                        text={`Save Sales Code List`}
                        onClick={(e) => {
                          e.preventDefault()
                          saveSalesCodeListData(e)
                        }}
                      />
                    </form>
                  )}
                </div>
                <div className="w-1/2 px-3">
                  <div className="text-white text-xl pb-3">
                    Salect Sales Code From List
                  </div>
                  <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {salesCodeList?.map(
                      (salesCodeListObj, salesCodeListIdx) => {
                        return (
                          <div
                            key={`sales-code-list-select-${salesCodeListIdx}`}
                          >
                            <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue">
                              <div className="w-1/12">
                                <CheckBox
                                  name={`sales-code-checkbox`}
                                  value={salesCodeListIdx}
                                  checked={
                                    selectedSalesCodeListId ==
                                    salesCodeListObj.id
                                  }
                                  onChange={() => {
                                    setSelectedSalesCodeListId(
                                      salesCodeListObj.id
                                    )
                                  }}
                                />
                              </div>
                              <div className="w-9/12">
                                <div className="px-2 text-xl w-3/4">
                                  {salesCodeListObj.name}
                                </div>
                              </div>
                              <div className="w-2/12 flex justify-end">
                                <Menu
                                  className="cursor-pointer"
                                  size="1.5rem"
                                  color="gray"
                                  onClick={() => {
                                    getSalesCodeDataForSelectedList(
                                      salesCodeListObj.id
                                    )
                                  }}
                                />
                                <Trash
                                  className="cursor-pointer text-red-600"
                                  size="1.5rem"
                                  color="gray"
                                  onClick={() => {
                                    deleteSalesCodeList(salesCodeListObj.id)
                                  }}
                                />
                              </div>
                            </div>
                            {selectedSalesCodeListData?.id ==
                              salesCodeListObj.id && (
                              <div className="flex flex-row flex-wrap items-center bg-tracer-lt-blue w-full py-2 px-3 border-b border-white">
                                {selectedSalesCodeListData?.data?.map(
                                  (salesCodeObj, salesCodeObjIdx) => {
                                    return (
                                      <span
                                        className={`rounded-xl  p-2 px-3 text-white cursor-pointer inline-block mr-1 mb-1 preview-sales-code bg-tracer-dark-blue`}
                                        key={`sales-code-selected-${salesCodeObjIdx}`}
                                        style={{ border: '1px solid' }}
                                      >
                                        {salesCodeObj.label}
                                      </span>
                                    )
                                  }
                                )}
                                {selectedSalesCodeListData?.data?.length ==
                                  0 && <NoRecordsFound />}
                              </div>
                            )}
                          </div>
                        )
                      }
                    )}
                    {salesCodeList?.length == 0 && <NoRecordsFound />}
                  </div>
                  <div className="flex justify-end py-3">
                    <Button
                      className={`cursor-pointer btn my-1 justify-end ml-2`}
                      text={`View Preview`}
                      onClick={(e) => {
                        e.preventDefault()
                        initializeBlockDiagramPreview(selectedSalesCodeListId)
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}

      <Button
        className={`cursor-pointer btn my-1 justify-end`}
        text={`Show Preview`}
        onClick={() => {
          showDiagramPreview()
        }}
      />
    </>
  )
}

export default FunctionalDiagramPreview
